<template>
  <nav class="sidebar" :class="{ 'sidebar--collapsed': collapsed }">
    <div class="sidebar-head">
      <div v-if="!collapsed" class="sidebar-brand">
        <img :src="logoUrl" alt="ISBET" class="sidebar-brand-img" />
      </div>
      <button
        class="sidebar-toggle"
        @click="$emit('update:collapsed', !collapsed)"
        :aria-label="collapsed ? 'Expandir menu' : 'Recolher menu'"
        :data-tooltip="collapsed ? 'Expandir menu' : 'Recolher menu'"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="3" y1="6" x2="21" y2="6"/>
          <line x1="3" y1="12" x2="21" y2="12"/>
          <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
      </button>
    </div>

    <div class="sidebar-nav">
      <button
        class="nav-item nav-item--search"
        @click="openGlobalSearch"
        :aria-label="collapsed ? 'Buscar (Ctrl+K)' : undefined"
        data-tooltip="Buscar · Ctrl+K"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Buscar</span>
        <kbd v-if="!collapsed" class="nav-kbd">Ctrl K</kbd>
      </button>

      <router-link
        to="/"
        class="nav-item"
        exact-active-class="nav-item--active"
        :aria-label="collapsed ? 'Dashboard' : undefined"
        data-tooltip="Dashboard"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="3" width="7" height="7" rx="1"/>
            <rect x="14" y="3" width="7" height="7" rx="1"/>
            <rect x="3" y="14" width="7" height="7" rx="1"/>
            <rect x="14" y="14" width="7" height="7" rx="1"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Dashboard</span>
      </router-link>

      <router-link
        v-if="can('foco.view')"
        to="/foco"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Modo Foco' : undefined"
        data-tooltip="Modo Foco"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4"/><line x1="12" y1="1" x2="12" y2="4"/><line x1="12" y1="20" x2="12" y2="23"/><line x1="1" y1="12" x2="4" y2="12"/><line x1="20" y1="12" x2="23" y2="12"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Modo Foco</span>
      </router-link>

      <router-link
        v-if="can('templates.view')"
        to="/templates"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Templates WA' : undefined"
        data-tooltip="Templates WA"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Templates WA</span>
      </router-link>

      <router-link
        v-if="can('resumo.view')"
        to="/resumo"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Resumo' : undefined"
        data-tooltip="Resumo"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="2" y="3" width="5" height="5" rx="1"/><rect x="9" y="3" width="5" height="5" rx="1"/><rect x="16" y="3" width="6" height="5" rx="1"/>
            <rect x="2" y="11" width="5" height="10" rx="1"/><rect x="9" y="11" width="5" height="6" rx="1"/><rect x="16" y="11" width="6" height="8" rx="1"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Resumo</span>
      </router-link>

      <router-link
        v-if="can('relatorioResolucao.view')"
        to="/relatorio-resolucao"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Relatório de Resolução' : undefined"
        data-tooltip="Relatório de Resolução"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Relatório de Resolução</span>
      </router-link>

      <router-link
        v-if="can('contacts.view')"
        to="/contacts"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Contatos' : undefined"
        data-tooltip="Contatos"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Contatos</span>
      </router-link>

      <router-link
        v-if="can('sla.view')"
        to="/sla"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'SLA' : undefined"
        data-tooltip="SLA"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">SLA</span>
      </router-link>

      <router-link
        v-if="can('teams.view')"
        to="/teams"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Times' : undefined"
        data-tooltip="Times"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Times</span>
      </router-link>

      <router-link
        v-if="can('macros.view')"
        to="/macros"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Macros' : undefined"
        data-tooltip="Macros"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Macros</span>
      </router-link>

      <router-link
        v-if="can('avaliacoes.view')"
        to="/avaliacoes"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Avaliações' : undefined"
        data-tooltip="Avaliações"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Avaliações</span>
      </router-link>

      <router-link
        v-if="can('fila.view')"
        to="/fila"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Fila de Chamados' : undefined"
        data-tooltip="Fila de Chamados"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="8" y1="6" x2="21" y2="6"/><line x1="8" y1="12" x2="21" y2="12"/>
            <line x1="8" y1="18" x2="21" y2="18"/>
            <line x1="3" y1="6" x2="3.01" y2="6"/><line x1="3" y1="12" x2="3.01" y2="12"/>
            <line x1="3" y1="18" x2="3.01" y2="18"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Fila</span>
      </router-link>

      <router-link
        v-if="can('agentes.view')"
        to="/agentes"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Agentes' : undefined"
        data-tooltip="Agentes"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
            <path d="M21 21v-2a4 4 0 0 0-3-3.87"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Agentes</span>
      </router-link>

      <router-link
        v-if="can('etiquetas.view')"
        to="/etiquetas"
        class="nav-item"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Etiquetas' : undefined"
        data-tooltip="Etiquetas"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"/>
            <line x1="7" y1="7" x2="7.01" y2="7"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Etiquetas</span>
      </router-link>

      <router-link
        v-if="can('slaMetro.view')"
        to="/sla-metro"
        class="nav-item nav-item--metro"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'SLA Metro (Telão)' : undefined"
        data-tooltip="SLA Metro (Telão)"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">SLA Telão</span>
      </router-link>
    </div>

    <div class="sidebar-shortcuts">
      <button
        class="nav-item nav-item--shortcuts"
        @click="toggleShortcutsHelp"
        :aria-label="collapsed ? 'Atalhos de teclado (?)' : undefined"
        data-tooltip="Atalhos de teclado · ?"
      >
        <span class="nav-icon nav-icon--shortcuts">?</span>
        <span v-if="!collapsed" class="nav-label">Atalhos</span>
        <kbd v-if="!collapsed" class="nav-kbd">?</kbd>
      </button>
    </div>

    <div v-if="can('admin.view')" class="sidebar-footer">
      <router-link
        to="/admin"
        class="nav-item nav-item--admin"
        active-class="nav-item--active"
        :aria-label="collapsed ? 'Admin' : undefined"
        data-tooltip="Admin"
      >
        <span class="nav-icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </span>
        <span v-if="!collapsed" class="nav-label">Admin</span>
      </router-link>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useStore } from 'vuex'
import { usePermission } from '@/composables/usePermission'
import { openGlobalSearch } from '@/composables/useGlobalSearch'
import { toggleShortcutsHelp } from '@/composables/useShortcutsHelp'
import { useLogo } from '@/composables/useLogo'

const { logoUrl } = useLogo()

defineProps<{
  collapsed: boolean
}>()

defineEmits<{
  'update:collapsed': [value: boolean]
}>()

const store   = useStore()
const { can } = usePermission()
</script>

<style scoped>
.sidebar {
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  width: 220px;
  background: var(--night);
  z-index: 300;
  display: flex;
  flex-direction: column;
  transition: width var(--ease);
  /* visible, não hidden: o tooltip custom (::after/::before) dos nav-items e
     do sidebar-toggle é posicionado fora da caixa do sidebar (à direita do
     ícone) — com overflow:hidden aqui ele nunca aparece, fica cortado antes
     de ser pintado. Nada dentro do sidebar depende de clipping (labels somem
     via v-if, não via CSS truncation animada), então não tem risco visual. */
  overflow: visible;
  box-shadow: 2px 0 18px rgba(2, 22, 39, 0.45);
}

.sidebar--collapsed {
  width: 64px;
}

.sidebar-head {
  display: flex;
  align-items: center;
  height: 66px;
  padding: 0 14px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
  gap: 10px;
  flex-shrink: 0;
  overflow: visible; /* mesma razão do .sidebar acima — libera o tooltip do sidebar-toggle */
}

.sidebar--collapsed .sidebar-head {
  justify-content: center;
  padding: 0;
}

.sidebar-brand {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.sidebar-brand-img {
  height: 36px;
  object-fit: contain;
  max-width: 100%;
}

.sidebar-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: var(--r-sm);
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.65);
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  transition: background var(--ease), color var(--ease);
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
}

.sidebar-nav {
  flex: 1;
  padding: 12px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow: visible; /* mesma razão do .sidebar acima — libera o tooltip dos nav-items */
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: var(--r-sm);
  color: rgba(255, 255, 255, 0.55);
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  transition: background var(--ease), color var(--ease);
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.85);
}

.nav-item--active {
  background: rgba(188, 12, 36, 0.18);
  color: #fff;
}

.nav-item--active .nav-icon {
  color: var(--red);
}

.sidebar--collapsed .nav-item {
  justify-content: center;
  padding: 10px;
}

.nav-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.nav-label {
  font-size: 13px;
  font-weight: 500;
}

.sidebar-footer {
  padding: 8px 8px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.07);
  flex-shrink: 0;
}

.nav-item--admin {
  color: rgba(255, 255, 255, 0.45);
}
.nav-item--admin:hover {
  color: rgba(255, 255, 255, 0.75);
}

.nav-item--search {
  width: 100%;
  border: none;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  margin-bottom: 4px;
  border: 1px solid rgba(255, 255, 255, 0.07);
}
.nav-item--search:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.85);
}

.sidebar-shortcuts {
  padding: 0 8px 4px;
  flex-shrink: 0;
}

.nav-item--shortcuts {
  width: 100%;
  border: none;
  background: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.35);
}

.nav-item--shortcuts:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.65);
}

.nav-icon--shortcuts {
  font-size: 14px;
  font-weight: 700;
  font-style: normal;
  width: 20px;
  height: 20px;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
}

.nav-kbd {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  padding: 1px 5px;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
  font-family: inherit;
  flex-shrink: 0;
}
.nav-item--metro {
  color: rgba(239, 100, 68, 0.75);
}
.nav-item--metro:hover {
  color: #fca5a5;
  background: rgba(239, 68, 68, 0.1);
}

/* Tooltip customizado (substitui o `title` nativo do navegador) — só nos
   itens de navegação quando o menu está recolhido (ícone sem label ao lado);
   o botão de recolher/expandir mostra em ambos os estados, pois é sempre
   ícone-only. Acessibilidade fica a cargo de aria-label, que continua sempre
   presente independente do CSS. */
.sidebar-toggle[data-tooltip],
.sidebar--collapsed .nav-item[data-tooltip] {
  position: relative;
  /* .nav-item usa overflow:hidden pra truncar o label (white-space:nowrap)
     — mas no colapsado não existe label nenhum renderizado (v-if some com
     ele), então liberar aqui não trunca nada e deixa o tooltip escapar. */
  overflow: visible;
}

.sidebar-toggle[data-tooltip]:hover::after,
.sidebar-toggle[data-tooltip]:focus-visible::after,
.sidebar--collapsed .nav-item[data-tooltip]:hover::after,
.sidebar--collapsed .nav-item[data-tooltip]:focus-visible::after {
  content: attr(data-tooltip);
  position: absolute;
  left: calc(100% + 12px);
  top: 50%;
  transform: translateY(-50%);
  background: var(--night);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: .2px;
  white-space: nowrap;
  padding: 7px 12px;
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(2, 22, 39, .35), 0 2px 8px rgba(2, 22, 39, .25);
  z-index: 500;
  pointer-events: none;
  animation: nav-tooltip-in .14s ease-out;
}

.sidebar-toggle[data-tooltip]:hover::before,
.sidebar-toggle[data-tooltip]:focus-visible::before,
.sidebar--collapsed .nav-item[data-tooltip]:hover::before,
.sidebar--collapsed .nav-item[data-tooltip]:focus-visible::before {
  content: '';
  position: absolute;
  left: calc(100% + 5px);
  top: 50%;
  transform: translateY(-50%);
  border: 6px solid transparent;
  border-right-color: var(--night);
  z-index: 500;
  pointer-events: none;
}

@keyframes nav-tooltip-in {
  from { opacity: 0; transform: translateY(-50%) translateX(-4px); }
  to   { opacity: 1; transform: translateY(-50%) translateX(0); }
}
</style>
